import React from 'react';

type MeetPresenceBadgeProps = {
  /** Null/undefined = no Aspen Meet room for this visit — hide the badge. */
  inRoom?: boolean | null;
  size?: 'sm' | 'md';
};

/** Live Aspen Meet presence — patient in the room vs waiting outside. */
export function MeetPresenceBadge({ inRoom, size = 'sm' }: MeetPresenceBadgeProps) {
  if (inRoom == null) return null;

  const inMeeting = inRoom === true;
  return (
    <span
      className={`meet-presence-badge meet-presence-badge--${inMeeting ? 'in' : 'out'}${
        size === 'md' ? ' meet-presence-badge--md' : ''
      }`}
      title={
        inMeeting
          ? 'Patient is currently in the meeting room'
          : 'Patient is not in the meeting room'
      }
    >
      <span className="meet-presence-badge__dot" aria-hidden />
      {inMeeting ? 'In meeting' : 'Not in room'}
    </span>
  );
}
